import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import type { UserActionsRequest, UserActionResponse } from "../types/api/logs";

const path = `admin/${process.env.REACT_APP_API_VERSION}/users`;

// Действия пользователей - Получить список
export function fetchUserActions(params: UserActionsRequest) {
  return mainAPI
    .get<UserActionResponse[]>(`analytics/${path}/actions`, { params })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}
// Действия пользователей - Экспортировать
// Фильтры и поиск те же, что в списке: иначе в файл уходит не то, что видно на экране,
// и выгрузку невозможно сопоставить с админкой
export function exportUserLogs(
  format: string,
  filters: Omit<UserActionsRequest, "limit" | "offset"> = {}
) {
  return mainAPI
    .get(`analytics/${path}/actions/export`, {
      params: {
        format,
        ...filters,
      },
      responseType: "blob",
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Ошибка при экспорте логов")
        );
      }
    );
}
